import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class IdpOneloginIcon extends BaseIcon {
  getChildren = () => [
    <defs>
      <clipPath id="idp-onelogin">
        <path transform="translate(-16650.668 -18619.959)" fill="#fbb" opacity=".7" d="M0 0h50v50H0z"/>
      </clipPath>
    </defs>,
    <g transform="translate(16650.668 18619.959)" clipPath="url(#idp-onelogin)">
      <path d="M-16625.669-18619.949a24.989 24.989 0 1 0 25 24.978 25 25 0 0 0-25-24.978Z" fill="#1c1f2a"/>
      <path d="M-16621.94-18586.121a.641.641 0 0 1-.719.719h-4.492a.641.641 0 0 1-.719-.719v-10.827h-3.437a.641.641 0 0 1-.719-.719v-4.494a.641.641 0 0 1 .719-.719h8.76c.472 0 .584.247.584.584v16.175Z" fill="#fff"/>
    </g>
  ]
  getViewBox = () => '0 0 50 50'
}
